var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"requirement"},[_c('b',{staticClass:"requirement-name"},[_vm._v(_vm._s(_vm.requirement.name))]),_vm._v(" "),(_vm.requirement.version)?_c('span',{staticClass:"requirement-version"},[_vm._v("@"+_vm._s(_vm.requirement.version))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }